import { DropdownMenuItem } from '@nesso/ui/primitives/dropdown-menu';

import { useSignOut } from '../model/use-sign-out';

export function SignOutMenuItem() {
    const { signOut, isPending } = useSignOut();

    return (
        <DropdownMenuItem disabled={isPending} onClick={signOut}>
            Sign out
        </DropdownMenuItem>
    );
}
